import AppShell from "../components/layout/AppShell";
import AppFooter from "../components/layout/AppFooter";
import TopNav from "../components/layout/TopNav";

import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function BecomeTechnician({ onLogout, onBack, onSuccess }) {
    const [cvFile, setCvFile] = useState(null);
    const [cvResult, setCvResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [existingCV, setExistingCV] = useState(null);
    const [checkingStatus, setCheckingStatus] = useState(true);

    const getHeaders = () => {
        const token = localStorage.getItem("token");
        return { Authorization: `Bearer ${token}` };
    };

    useEffect(() => {
        const checkExisting = async () => {
            try {
                const res = await axios.get(`${API}/technicians/me`, { headers: getHeaders() });
                setExistingCV(res.data);
            } catch {
                setExistingCV(null);
            } finally {
                setCheckingStatus(false);
            }
        };
        checkExisting();
    }, []);

    const uploadCV = async (e) => {
        e.preventDefault();
        if (!cvFile) return;
        setLoading(true);
        const formData = new FormData();
        formData.append("cv", cvFile);
        try {
            const res = await axios.post(`${API}/cv/upload`, formData, {
                headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
            });
            setCvResult(res.data);
            if (res.data?.validated) {
                setTimeout(() => onSuccess(), 2000);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (checkingStatus) {
        return (
            <AppShell header={<TopNav isLoggedIn={true} onLogout={onLogout} onNavigate={onBack} />} footer={<AppFooter onNavigate={onBack} />}>
                <div style={{ maxWidth: 700, margin: "0 auto" }}>
                    <p className="muted">Chargement…</p>
                </div>
            </AppShell>
        );
    }

    return (
        <AppShell header={<TopNav isLoggedIn={true} onLogout={onLogout} onNavigate={onBack} />} footer={<AppFooter />}>
            <div style={{ maxWidth: 700, margin: "0 auto" }}>
                <button className="btn btn-ghost" onClick={onBack} style={{ marginBottom: 16 }}>
                    ← Retour
                </button>

                <h2 className="page-title">Devenir technicien</h2>

                {existingCV && (
                    <div className="section-card">
                        <div className="section-head">
                            <h3 className="section-title">Votre dossier actuel</h3>
                        </div>

                        <div className="card" style={{ marginBottom: 0 }}>
                            <div className="tech-score">
                                <span className="tech-score__value">{existingCV.score}</span>
                                <span className="tech-score__max">/100</span>
                            </div>
                            <div className="tech-bar">
                                <div
                                    className="tech-bar__fill"
                                    style={{ width: `${Math.max(0, Math.min(100, existingCV.score || 0))}%` }}
                                    data-score={existingCV.score}
                                />
                            </div>
                            <div className="tech-meta" style={{ marginTop: 10 }}>
                                <div>
                                    <span className="muted">Statut :</span>{" "}
                                    <strong style={{ color: existingCV.validated ? '#4caf50' : '#f59e0b' }}>
                                        {existingCV.validated ? '✓ Validé' : '⏳ En attente'}
                                    </strong>
                                </div>
                                {existingCV.skills?.length > 0 && (
                                    <div>
                                        <span className="muted">Compétences :</span>{" "}
                                        <strong>{existingCV.skills.join(", ")}</strong>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <div className="section-card">
                    <div className="section-head">
                        <h3 className="section-title">
                            {existingCV ? "Soumettre un nouveau CV" : "Déposer votre CV"}
                        </h3>
                    </div>

                    <p className="muted" style={{ marginTop: 0 }}>
                        Notre IA analysera votre profil. Validation automatique si score ≥ 60/100.
                    </p>

                    <form onSubmit={uploadCV} className="stack">
                        <div
                            onClick={() => document.getElementById('cv-upload').click()}
                            style={{
                                padding: "12px 16px",
                                borderRadius: 12,
                                border: "1px dashed rgba(110,86,207,0.4)",
                                background: "rgba(110,86,207,0.06)",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                fontSize: 13,
                                color: "rgba(200,200,215,0.85)",
                                transition: "all 160ms ease"
                            }}
                            onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(110,86,207,0.7)"}
                            onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(110,86,207,0.4)"}
                        >
                            <span style={{ fontSize: 18 }}>📄</span>
                            <span>{cvFile ? cvFile.name : "Cliquer pour choisir un fichier PDF"}</span>
                            <input
                                id="cv-upload"
                                type="file"
                                accept=".pdf"
                                style={{ display: "none" }}
                                onChange={(e) => setCvFile(e.target.files?.[0] || null)}
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading || !cvFile}
                            className="btn btn-primary"
                        >
                            {loading ? "Analyse en cours..." : "Soumettre mon CV"}
                        </button>
                    </form>

                    {cvResult && (
                        <div className="card" style={{ marginTop: 16 }}>
                            <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>
                                Résultat de l'analyse IA
                            </div>
                            <div className="tech-score">
                                <span className="tech-score__value">{cvResult.score}</span>
                                <span className="tech-score__max">/100</span>
                            </div>
                            <div className="tech-bar">
                                <div
                                    className="tech-bar__fill"
                                    style={{ width: `${Math.max(0, Math.min(100, cvResult.score || 0))}%` }}
                                    data-score={cvResult.score}
                                />
                            </div>
                            {cvResult.red_flags?.length > 0 && (
                                <div className="tech-warn">⚠️ {cvResult.red_flags.join(", ")}</div>
                            )}
                            {cvResult.validated ? (
                                <div className="tech-ok">✓ Score suffisant — redirection en cours…</div>
                            ) : (
                                <div className="tech-bad">Score insuffisant. Vous pouvez resoumettre un CV amélioré.</div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </AppShell>
    );
}